import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import adrActions from "../../_actions/adrActions";
import AlertModal from "../_common/AlertModal";
import cem4907PdfActions from "../../_actions/cem4907PdfActions";
import { validateEmail } from "../../_utils/generalUtils";
import AlertBox from "../_common/AlertBox";

export default function AdrTentativeAgreementSendEmailModalV3(props) {
  const {
    showModal,
    toggleModal,
    tabId,
    taClientId,
    isLocked,
    caltransEmail,
    contractorEmail,
  } = props;

  const dispatch = useDispatch();

  const sending = useSelector((state) => state.adr.sendingEmail);
  const tas = useSelector(
    (state) => state.adr.openAdrs[tabId].tentativeAgreements || null
  );
  const ta = useMemo(
    () => (tas || []).find((ta) => ta.clientId === taClientId) || null,
    [taClientId]
  );

  const [formErrors, setFormErrors] = useState({
    caltransEmail: null,
    contractorEmail: null,
  });
  const [sendToCaltransEmail, setSendToCaltransEmail] = useState(
    caltransEmail ? true : false
  );
  const [_caltransEmail, setCaltransEmail] = useState(caltransEmail);
  const [sendToContractorEmail, setSendToContractorEmail] = useState(
    contractorEmail ? true : false
  );
  const [_contractorEmail, setContractorEmail] = useState(contractorEmail);

  useEffect(() => {
    const _formErrors = { ...formErrors };
    if (sendToCaltransEmail) {
      if (!_caltransEmail) _formErrors.caltransEmail = "Required";
      else {
        if (!validateEmail(_caltransEmail)) _formErrors.caltransEmail = "Invalid email";
        else _formErrors.caltransEmail = null;
      }
    } else _formErrors.caltransEmail = null;

    if (sendToContractorEmail) {
      if (!_contractorEmail) _formErrors.contractorEmail = "Required";
      else {
        if (!validateEmail(_contractorEmail))
          _formErrors.contractorEmail = "Invalid email";
        else _formErrors.contractorEmail = null;
      }
    } else _formErrors.contractorEmail = null;
    setFormErrors(_formErrors);
  }, [sendToCaltransEmail, sendToContractorEmail, _caltransEmail, _contractorEmail]);

  const handleChange_check = (e) => {
    if (e.target.name === "sendToCaltransEmail") setSendToCaltransEmail(e.target.checked);
    if (e.target.name === "sendToContractorEmail")
      setSendToContractorEmail(e.target.checked);
  };

  const handleChange = (e) => {
    if (e.target.name === "caltransEmail") setCaltransEmail(e.target.value);
    if (e.target.name === "contractorEmail") setContractorEmail(e.target.value);
  };

  const handleClick_send = (e) => {
    e.preventDefault();
    if (ta) {
      const emailTo = {
        to: [_caltransEmail, _contractorEmail],
        replyTo: _caltransEmail,
      };
      dispatch(
        cem4907PdfActions.sendTentativeAgreementEmail(ta.tentativeAgreementId, emailTo)
      );
    }
    toggleModal();
  };

  const closeBtn = (
    <button className="close" onClick={() => toggleModal(!showModal)}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <React.Fragment>
      <Modal isOpen={showModal} toggle={toggleModal} fade={false} size={"md"}>
        <ModalHeader toggle={toggleModal} className="bg-info text-white" close={closeBtn}>
          <FontAwesomeIcon icon="paper-plane" className="fa-fw mr-2" />
          Email Tentative Agreement (PDF)
        </ModalHeader>
        <ModalBody>
          {!isLocked && (
            <AlertBox color="warning" icon="exclamation-triangle" className="mb-2">
              This TA is still pending, and the PDF will be created with a 'pending'
              watermark.
            </AlertBox>
          )}
          <div className="form-row px-1 mb-2">
            <span className="font-weight-bold">Email PDF to:</span>
          </div>
          <div className="form-row form-group mb-2">
            <div className="col-lg-3 my-auto">
              <div className="custom-control-inline custom-control custom-checkbox">
                <input
                  type="checkbox"
                  name="sendToCaltransEmail"
                  id="sendToCaltransEmail"
                  className="custom-control-input my-auto"
                  value={sendToCaltransEmail}
                  checked={sendToCaltransEmail}
                  onChange={handleChange_check}
                />
                <label
                  htmlFor="sendToCaltransEmail"
                  className="custom-control-label my-auto"
                >
                  CT:
                </label>
              </div>
            </div>
            <div className="col-lg-9">
              <input
                id="caltransEmail"
                name="caltransEmail"
                className="form-control"
                value={_caltransEmail}
                onChange={handleChange}
                disabled={!sendToCaltransEmail}
              />
              {formErrors.caltransEmail && (
                <span className="error-small">
                  <small>{formErrors.caltransEmail}</small>
                </span>
              )}
            </div>
          </div>
          <div className="form-row form-group mb-0">
            <div className="col-lg-3 my-auto">
              <div className="custom-control-inline custom-control custom-checkbox">
                <input
                  type="checkbox"
                  name="sendToContractorEmail"
                  id="sendToContractorEmail"
                  className="custom-control-input my-auto"
                  value={sendToContractorEmail}
                  checked={sendToContractorEmail}
                  onChange={handleChange_check}
                />
                <label
                  htmlFor="sendToContractorEmail"
                  className="custom-control-label my-auto"
                >
                  Contractor:
                </label>
              </div>
            </div>
            <div className="col-lg-9">
              <input
                id="contractorEmail"
                name="contractorEmail"
                className="form-control"
                value={_contractorEmail}
                onChange={handleChange}
                disabled={!sendToContractorEmail}
              />
              {formErrors.contractorEmail && (
                <span className="error-small">
                  <small>{formErrors.contractorEmail}</small>
                </span>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <div className="form-row form-group">
            <button
              name="cancel"
              id="cancel"
              className="btn btn-secondary mr-2"
              onClick={toggleModal}
            >
              Cancel
            </button>
            <button
              name="send"
              id="send"
              className="btn btn-primary"
              onClick={handleClick_send}
              disabled={
                sending ||
                formErrors.caltransEmail ||
                formErrors.contractorEmail ||
                (!sendToCaltransEmail && !sendToContractorEmail)
              }
            >
              {sending && (
                <span className="mr-2 mt-1">
                  <FontAwesomeIcon icon="spinner" style={{ color: "white" }} spin />
                </span>
              )}
              <FontAwesomeIcon icon="paper-plane" className="fa-fw mr-2" />
              <b>Send</b>
            </button>
          </div>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}
